/**
 * Classe responsável por excluir em lotes no grid.
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 30/07/2013
 *
 */


Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

/**
 *
 * @param customOptions {checkOnClickRow: boolean}
 * @returns {Monet.Grid.ActionsModules.CheckBoxColumn}
 */

Monet.Grid.ActionsModules.CheckBoxColumn = function (customOptions) {

    this.currentCount = 0;
    this.maxCountAllowed = 1000;
    this.isLoadingCount = false;

    let inputCheckBoxChecked = "<input type='checkbox' checked />",
      inputCheckBoxNotChecked = "<input type='checkbox' />",
      inputCheckBoxDisabled = "<input type='checkbox' disabled='disabled' />",
      event = new Slick.EventHandler(),
      rowsSelected = [],
      columnId = "checkBoxColumn",
      options = {
          checkOnClickRow: true,
          autoEdit: false
      };

    if (typeof customOptions !== "undefined") {
        options = customOptions;
    }

    var removeMenu = function (entity) {

        var selector;
        var menu;

        if (entity) {

            selector = '#' + entity + ' .MonetUIFloatMenu';
            menu = document.querySelector(selector);

            if (menu) {
                menu.parentNode.removeChild(menu);
            }
        }

    };

    const updateSelectedCount = (args, { clickedSelectAll } = {}) => {

        const namespace = args.grid.getEntity();
        const lookupElement = App.Forms[namespace].lookupElement;

        // Only update selected items counter on Lookup List fields
        if (lookupElement && lookupElement.statusBarContainer) {
            Monet.Session[namespace] = Monet.Session[namespace] || {};
            const rowsSelected = args.grid.getSelectedRows();
            const selectedAll = Monet.Session[namespace].selectedAll || false;
            const allDataSelectedLength = Monet.Session[namespace].allDataSelectedLength || 0;
            const selectAllCheckbox = lookupElement.rootEl.querySelector('.slick-header-columns input[type=checkbox]');

            const setTextContainer = (key, valueInResource) => {
                lookupElement.statusBarText.innerText = Monet.I18n.getResourcesByKey(key, valueInResource);
            };

            const setCurrentLength = (length) => {
                let key = '', valueInResource;
                this.currentCount = length;
                if (length > this.maxCountAllowed) {
                    lookupElement.btnGetItemsChecked.classList.add('disabled');
                    lookupElement.statusBarContainer.classList.add('showError');
                    key = 'LookupList.maxSelectedError';
                    valueInResource = this.maxCountAllowed;
                }
                else {
                    if (!this.isLoadingCount) {
                        lookupElement.btnGetItemsChecked.classList.remove('disabled');
                    }
                    lookupElement.statusBarContainer.classList.remove('showError');
                    if (length === 0) {
                        key = 'LookupList.noItemSelected';
                    } else if (length === 1) {
                        key = 'LookupList.oneItemSelected';
                    } else if (length > 1) {
                        key = 'LookupList.multipleItemsSelected';
                        valueInResource = length;
                    }
                }
                setTextContainer(key, valueInResource);
            };

            const getAllFilteredDataCount = () => {
                if (!this.isLoadingCount) {
                    if (!allDataSelectedLength) {
                        lookupElement.btnGetItemsChecked.classList.add('disabled');
                        lookupElement.statusBarContainer.classList.add('showLoading');
                        this.isLoadingCount = true;
                        setTextContainer('');

                        const filter = lookupElement.filter.criteriaChain;
                        filter.aggregate = [{ function: "COUNT", attr: ["id"] }];
                        delete filter.sort;

                        const ajax = new Monet.Ajax();
                        ajax.url = `/${lookupElement.lookUpEntity}/aggregate`;
                        ajax.data = filter;
                        ajax.method = 'post';
                        ajax.success = (data) => {
                            const length = data.count.total;
                            Monet.Session[namespace].allDataSelectedLength = parseInt(length);
                            lookupElement.statusBarContainer.classList.remove('showLoading');
                            this.isLoadingCount = false;
                            if (selectAllCheckbox.checked) {
                                Monet.Session[namespace].selectedAll = true;
                                args.grid.setSelectedRows(rowsSelected)
                                setCurrentLength(length);
                            }
                        };
                        ajax.error = () => {
                            lookupElement.statusBarContainer.classList.remove('showLoading');
                            lookupElement.statusBarContainer.classList.add('showError');
                            this.isLoadingCount = false;
                            setTextContainer('LookupList.countRequestError');
                        };
                        ajax.send();
                    }
                    else {
                        Monet.Session[namespace].selectedAll = true;
                        setCurrentLength(allDataSelectedLength);
                    }
                }
            };

            if (clickedSelectAll) {
                Monet.Session[namespace].notSelectedItems = null;
                if (selectAllCheckbox.checked) {
                    getAllFilteredDataCount();
                } else {
                    Monet.Session[namespace].selectedAll = false;
                    setCurrentLength(0);
                }
            } else if (selectAllCheckbox.checked) {
                Monet.Session[namespace].notSelectedItems = null;
                getAllFilteredDataCount();
            } else if (!selectAllCheckbox.checked) {
                if (selectedAll) {
                    const allDataArray = args.grid.getData().getItems();
                    const selectedArray = args.grid.getItemsSelected();
                    const notSelectedItems = allDataArray.reduce((result, data) => {
                        if (selectedArray.filter((selected) => data.idOfObject == selected.attributes.id).length == 0) {
                            result.push({ attr: "id", neq: data.idOfObject });
                        }
                        return result;
                    }, []);
                    Monet.Session[namespace].notSelectedItems = notSelectedItems;
                    const length = allDataSelectedLength - notSelectedItems.length;
                    if (Math.abs(length - this.currentCount) > 1) {
                        Monet.Session[namespace].selectedAll = false;
                        setCurrentLength(rowsSelected.length);
                    } else {
                        setCurrentLength(length);
                    }
                } else {
                    setCurrentLength(rowsSelected.length);
                }
            }

        }

    };

    const getDisabledRows = (grid) => {
        if (!options.isDisabled || grid.getDataLength() <= 0) {
            return [];
        }
        return [...Array(grid.getDataLength()).keys()]
          .filter(row => options.isDisabled && options.isDisabled(row));
    }

    const checkHeaderIfAllItemsChecked = (selectedRows, grid) => {
        let  inputCheckBox = inputCheckBoxNotChecked;

        try {
            removeMenu();

            const disabledRows = getDisabledRows(grid);

            const isAllAllowedRowsSelected = (selectedRows.length + disabledRows.length) === grid.getDataLength();

            if (isAllAllowedRowsSelected && selectedRows.length > 0) {
                inputCheckBox = inputCheckBoxChecked;
            }

            grid.updateColumnHeader(columnId, inputCheckBox, "");

        } catch (e) {
            new Monet.Exception.ReturnError(this, "Error on check if all itens checked.").console();
        }
    };

    var addItemsMarked = function (selectedRows, grid) {

        const items = {};

        selectedRows.forEach((selectedRow) => {
            items[selectedRow] = true;
            if (items[selectedRow] !== rowsSelected[selectedRow]) {
                grid.invalidateRow(selectedRow);
                delete rowsSelected[selectedRow];
            }
        });

        return items;

    };

    var updateItemsCleared = function (grid) {

        for (var i in rowsSelected) {
            grid.invalidateRow(i);
        }

    };

    var toggleRowSelection = function (row, grid) {
        try {
            const selectedRows = grid.getSelectedRows() || [];

            if (rowsSelected[row]) {
                const newArrayRows = $.grep(selectedRows, function (n) {
                    return n !== row;
                });

                grid.setSelectedRows(newArrayRows);
            } else if (options.isDisabled) {
                if (!options.isDisabled(row)) {
                    grid.setSelectedRows(selectedRows.concat(row));
                }
            } else {
                grid.setSelectedRows(selectedRows.concat(row));
            }
        } catch (e) {
            new Monet.Exception.ReturnError(this, "Error on toggleRowSelection").console();
        }
    };

    const handleEventsClass = (grid) => {
        const entity = grid.getEntity();
        const toEnableButton = grid.getSelectedRows().length > 0;

        switch (true) {
            case /^IntegrationLog_/gi.test(entity): {
                const action = Monet.Grid.ActionsModules.IntegrationLogRetry();

                action.handleButtonDisable(entity, toEnableButton);

                break;
            }
            default: {
                const action = Monet.Grid.ActionsModules.ButtonEventCheckBox();

                action.handleButtonDisable(entity, toEnableButton);

                break;
            }
        }
    };

    this.handlerOnClick = function (e, args) {

        var error = null;
        var grid;

        try {

            grid = args.grid;

            removeMenu(grid.getOptions().entity);

            toggleRowSelection(args.row, args.grid);

            if (grid.getColumnIdByCellNumber(args.cell) === 'checkBoxColumn') {
                grid.focus();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }

        } catch (message) {

            error = new Monet.Exception.ReturnError(this,
              "Error on handler on click checkbox column.");
            error.console();

        }

    };

    this.handlerOnClickHeader = function (e, args) {

        var error = null,
          grid = args.grid,
          rows = [];

        try {

            if ($(e.target).is(":checked")) {

                for (var i = 0; i < grid.getDataLength(); i++) {
                    if (!options.isDisabled || !options.isDisabled(i)) {
                        rows.push(i);
                    }
                }

                grid.setSelectedRows(rows);

            } else {

                grid.setSelectedRows([]);

            }

            updateSelectedCount(args, { clickedSelectAll: true });

            e.stopPropagation();
            e.stopImmediatePropagation();

        } catch (message) {

            error = new Monet.Exception.ReturnError(this,
              "Error on handler on click header checkbox column.");
            error.console();

        }

    };


    this.handlerRowChanged = function (e, args) {

        var error = null,
          grid = args.grid,
          selectedRows = grid.getSelectedRows(),
          items = {};

        try {
            items = addItemsMarked(selectedRows, grid);

            updateItemsCleared(grid);

            rowsSelected = items;

            grid.render();

            checkHeaderIfAllItemsChecked(selectedRows, grid);
            
            updateSelectedCount(args);

            handleEventsClass(grid);
        } catch (message) {

            error = new Monet.Exception.ReturnError(this,
              "Error on handler row changed checkbox.");
            error.console();

        }

    };

    this.checkBoxColumnFormatter = (row) => {
        let checkBox = inputCheckBoxNotChecked;

        try {

            const isRowDisabled = options.isDisabled && options.isDisabled(row);

            if (isRowDisabled) {
                checkBox = inputCheckBoxDisabled;
                delete rowsSelected[row];
            } else if (rowsSelected[row]) {
                checkBox = inputCheckBoxChecked;
            }

            return checkBox;
        } catch (e) {
            new Monet.Exception.ReturnError(this, "Error on checkbox column formatter.").console();
        }
    };

    this.getColumn = () => {

        return {
            id: columnId,
            name: inputCheckBoxNotChecked,
            toolTip: "",
            field: "sel",
            width: 30,
            resizable: false,
            sortable: false,
            cssClass: 'checkboxEvent',
            formatter: this.checkBoxColumnFormatter
        };

    };

    this.registerEvents = function (grid) {

        if (options.checkOnClickRow === true) {
            event.subscribe(grid.onSelectedRowsChanged, this.handlerRowChanged);
        }

        event.unsubscribe(grid.onClick, this.handlerOnClick, false);
        event.subscribe(grid.onClick, this.handlerOnClick, false);

        event.unsubscribe(grid.onHeaderClick, this.handlerOnClickHeader);
        event.subscribe(grid.onHeaderClick, this.handlerOnClickHeader);

    };
};
